import { BriefType } from '@/components/FeedCard/BriefIcon/types';
import { queryFn } from './hooks/useNewsFeed';

type NewsType = {
  [K in keyof typeof BriefType]: number;
};

export const getTotalNewsPerType = (
  newsFeed: Awaited<ReturnType<typeof queryFn>> | undefined
) => {
  if (!newsFeed) return {} as NewsType;
  const totalNewsPerType = newsFeed.reduce((acc, item) => {
    const name = item.data?.name;
    if (name) {
      acc[name] = (acc[name] || 0) + 1;
    }
    return acc;
  }, {} as NewsType);

  return totalNewsPerType;
};
